// height helpers shared by Personal Details and Measurements
// heights are shown as whole numbers: whole cm, or whole feet + whole inches
//==============================

export const CM_PER_INCH = 2.54

export const HEIGHT_LIMITS = {
    feet: { min: 1, max: 8 },
    inch: { min: 0, max: 11 },
    cm: { min: 50, max: 250 },
}

// exact cm for a feet + inch height (kept exact for BMI)
export const feetInchToCm = (ft, inch) =>
    ((Number(ft) || 0) * 12 + (Number(inch) || 0)) * CM_PER_INCH

// split a number of inches into whole feet and whole inches
// rounds the total first so the result is never "5 ft 12 in"
export const inchesToFeetInch = (totalInches) => {
    const rounded = Math.round(Number(totalInches) || 0)
    return { ft: Math.floor(rounded / 12), inch: rounded % 12 }
}

export const cmToFeetInch = (cm) => inchesToFeetInch((Number(cm) || 0) / CM_PER_INCH)

// decimal feet (e.g. 5.5 ft) to whole feet + whole inches (5 ft 6 in)
export const decimalFeetToFeetInch = (feet) => inchesToFeetInch((Number(feet) || 0) * 12)

export const formatFeetInch = ({ ft, inch }) => `${ft} ft ${inch} in`

// read the stored patient height ("5.7" feet.inch text in height_inch, or height_cm)
// into whole-number input values; older decimal values are rounded
export const parseStoredHeight = (heightInch, heightCm) => {
    if (heightInch) {
        const [feetPart, ...inchParts] = String(heightInch).split('.')
        const { ft, inch } = inchesToFeetInch(
            (parseInt(feetPart, 10) || 0) * 12 + (parseFloat(inchParts.join('.')) || 0)
        )
        return { unit: 'feet', ft, inch, cm: Math.round(feetInchToCm(ft, inch)) }
    }
    if (heightCm) {
        const cm = Math.round(parseFloat(heightCm) || 0)
        return { unit: 'cm', ...cmToFeetInch(cm), cm }
    }
    return { unit: 'feet', ft: '', inch: '', cm: '' }
}
